import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const cleanupModalArtifacts = () => {
  document.querySelectorAll(".modal-backdrop").forEach((element) => element.remove());
  document.body.classList.remove("modal-open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
};

const ModalBackdropCleanup = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    cleanupModalArtifacts();

    const timeoutId = window.setTimeout(() => {
      cleanupModalArtifacts();
    }, 300);

    return () => window.clearTimeout(timeoutId);
  }, [pathname]);

  return null;
};

export default ModalBackdropCleanup;
